import React from 'react'
import { useTranslation } from 'react-i18next'
import { AlertBox, PhoneInput, TextInput } from '@life-line-lab/components-react';
// ANTD
import { Col, Row } from 'antd';

const EmergencyContacts = ({
    input,
    error,
    handleFieldChange,
    handlePhoneChange,
}) => {

    const { t } = useTranslation();

    return (
        <React.Fragment>
            {
                input._id ? null :
                    <div className="center header-title">
                        {t("title.emergencyContactDetails").toUpperCase()}
                    </div>
            }
            <Row gutter={[15, 15]} className="mt-50">
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        label={t("label.emergencyContactName")}
                        placeholder={t("txt.emergencyContactName")}
                        value={input.emergencyContactName}
                        name="emergencyContactName"
                        onChange={handleFieldChange}
                    />
                    <AlertBox text={error.emergencyContactName} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <TextInput
                        label={t("label.relationshipWithRider")}
                        placeholder={t("txt.relationshipWithRider")}
                        value={input.relationship}
                        name="relationship"
                        onChange={handleFieldChange}
                    />
                    <AlertBox text={error.relationship} />
                </Col>
                <Col xs={24} sm={24} md={12}>
                    <PhoneInput
                        isError={!!error.emergencyContactNo}
                        label={t('label.emergencyContactNo')}
                        name="emergencyContactNo"
                        value={input.emergencyContactNo}
                        onChange={(value) => handlePhoneChange(value, 'emergencyContactNo')}
                    />
                    <AlertBox text={error.emergencyContactNo} />
                </Col>
            </Row>
        </React.Fragment>
    )
}

export default EmergencyContacts